import React from "react";
import { getShortDescription, FILTER_DOCUMENT_PATH, FILTER_BY, BRX_API_HOST, BRX_HOST } from "./APIUtils";
import { LabelContext, LabelContextComponent } from "./label.context";

export const GeneralContext = React.createContext<any>(null!);

export const GeneralContextComponent = (props: any) => {


    const { t } = React.useContext(LabelContext);

    const allFamilyObject = { 
        name: t('familyAll'),  
        value: "all", 
        category_code: "colazione",
        disabledImage: BRX_HOST + "/binaries/content/gallery/landing-colours/icons/view-all.png", 
        activeImage: BRX_HOST + "/binaries/content/gallery/landing-colours/icons/view-all.png" ,
        backgroundColor: '#FFFFFF'
    }
    const allColorObject = { 
        name: t('colorAll'),  
        value: "all", 
        disabledImage: BRX_HOST + "/binaries/content/gallery/landing-colours/icons/view-all.png", 
        activeImage: BRX_HOST + "/binaries/content/gallery/landing-colours/icons/view-all.png" ,
    }

    /* === DATI === */
    
    // New version
    const [colors, setColors]       = React.useState([]);
    const [families, setFamilies]   = React.useState([]);
    const [products, setProducts]   = React.useState([]);
    const [models, setModels]       = React.useState([]);
    const [isMobile, setIsMobile]       = React.useState(true);
    
    
    const [changeUrl, setChangeUrl]       = React.useState(false);

    const [start, setStart] = React.useState(0);
    const [selectedColor, setSelectedColor] = React.useState<any>(null!);
    const [selectedFamily, setSelectedFamily] = React.useState<any>(allFamilyObject!);
    const [selectedSku, setSelectedSku] = React.useState();
    const [selectedRetailer, setSelectedRetailer] = React.useState();
    const [familyAttribute, setFamilyAttribute] = React.useState([]);
    const [mdaFamilyList, setMdaFamilyList] = React.useState<string[]>([]);

    // commenta

    //const [activeFilters, setActiveFilters] = React.useState({ "colors": [], "family": [] });
    const [selectedFilters, setSelectedFilters] = React.useState({ "colors": [], "family": [] });
    const [startState, setStartState] = React.useState(true);

    //const [filterColor, setFilterColor] = React.useState<any>([]);
    //const [filterAttribute, setFilterAttribute] = React.useState<any>([]);
    const [loading, setLoading] = React.useState(1);

    const productsToSkip = ["SMF23BLIT","SMF33CRIT","SMF43RDIT"]

    const handleBack = () =>{
        if(selectedSku){
            setSelectedSku(null!)
        }else{            
            if(selectedColor){
                setSelectedColor(null!);
                if(selectedFamily){
                    setSelectedFamily(allFamilyObject);
                }
            }else{
                setSelectedFamily(allFamilyObject);
                setStart(0)
            }
        }
    }

    const setHashUrl = React.useCallback(() => {
        const params = new URLSearchParams();
      
        if (isMobile) {
          if (selectedFamily?.value) {
            params.set("category", selectedFamily.value);
          }
          if (selectedColor?.value) {
            params.set("color", selectedColor.value);
          }
          if (selectedSku) {
            params.set("sku", selectedSku);
          }
          if (selectedRetailer) {
            params.set("retailer", selectedRetailer);
          }
        }
      
        const queryString = params.toString() ? `?${params.toString()}` : window.location.pathname;
      
        if (window.location.search !== `?${params.toString()}`) {
          window.history.pushState({ path: queryString }, "", queryString);
        }
      }, [isMobile, selectedFamily, selectedColor, selectedSku, selectedRetailer]);
      
      React.useEffect(() => {
        setHashUrl();
      }, [setHashUrl]);


    
    /** 
        Richiama Prodotti e Filtri
        Rielabora i prodotti per semplificare la lettura successiva dei dati
        Estrae i modelli
    **/
    const init = () => {

        let requestOptionsForProduct = {}

        const requestOptionsForFilter = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(
                {
                    "filter_documents_path": FILTER_DOCUMENT_PATH
                }
            )
        }

        let _colors:any;


        fetch(BRX_API_HOST + "/v1/beans/retrieve_filters", requestOptionsForFilter)
            .then(res => res.json())
            .then((result) => {
                if (result.code === 200) {
                    const attributes = JSON.parse(result.attributes);
                    _colors = JSON.parse(result.colors);
                    setColors(_colors)
                    
                    let familyFiltersValues: any[] = []
                    let _attributes = attributes.map(
                        (attribute:any) => {
                            if(attribute.applianceType === "MDA") {
                                setMdaFamilyList(prev => [...prev, attribute.value]);
                            }
                            const item = {
                                family: attribute.value,
                                aesthetics: attribute.aestheticValues ? attribute.aestheticValues : []
                            }
                            familyFiltersValues.push(item)
                            return { ...attribute,"activeImage": attribute.activeImage?.replace('/brx%3AdoubleDeskLarge','')};
                            
                        }
                    );

                    requestOptionsForProduct = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(
                            {
                                family_filters: familyFiltersValues
                            }
                        )
                    }

                    setFamilies(_attributes)                    
                    
                    //setFilterAttribute(attributes);
                } else {
                    console.log(result.message)
                }
            },
                (error) => {
                    console.log(error);
                })
            .then(
                () => fetch(BRX_API_HOST + "/v1/beans/products", requestOptionsForProduct)
                    .then(res => res.json())
                    .then((result) => {
                        if (result.code === 200) {
                            
                            const newData = JSON.parse(result.products).filter( (obj:any) => {return !productsToSkip.includes(obj.sku) }  ).map((obj: { mainImage: any; description: any; attribute: any; color: any; sku: any; basicInfo: any, images: any, title: any, finishing: any}) => {
                                let model = obj.sku.match(/([^\d]+)([\d]+).*/i);

                                let model_code = ""
                                if(model)
                                    model_code = model[1]+model[2]
                                else
                                    model_code = obj.sku.substring(0, 5)
                                return {
                                    "image": obj.mainImage ? obj.mainImage : "https://www.smeg.com/webfiles/latest/images/product_placeholder.png",
                                    "description": obj.description,
                                    "attribute": obj.attribute,
                                    "family": obj.attribute,
                                    "color": obj.color,
                                    "sku": obj.sku,
                                    "model": model_code,
                                    "basicInfo": JSON.parse(obj.basicInfo),
                                    "images": obj.images,
                                    "title": obj.title,
                                    "finishing": obj.finishing
                                }

                            })
                                                        
                            setProducts(newData);
                            /* Modelli */
                            let newModels = newData.reduce( 
                                (models: any, currentProduct: any) => { 
                                    if(!models) models = [];
                                    
                                    if(!models.find( (model:any) => (model.model==currentProduct.model) )){
                                        let newModel = { model: currentProduct.model, family:currentProduct.attribute, attribute: currentProduct.attribute, category: currentProduct.category, products:[], description: currentProduct.description }
                                        
                                        newModel.description = getShortDescription(currentProduct.description, currentProduct.category, currentProduct.model);
                                        let tmp_desc = t(currentProduct.model)
                                        if(tmp_desc.indexOf("???") == -1)
                                            newModel.description = tmp_desc

                                        newModel.products = newData.filter( (product:any) => (product.model == currentProduct.model )).map(
                                                (product:any) => {
                                                    let productWithColors = { ...product, colorImage:"", colorName:""}
                                                    const finishingValue = productWithColors.finishing;
                                                    const selectedColor = _colors.find((c: any) => c.value == productWithColors.color && c.finishingValue === finishingValue) ?? _colors.find((c: any) => c.value == productWithColors.color);

                                                    productWithColors.colorName = selectedColor?.name;
                                                    productWithColors.colorImage = selectedColor?.activeImage?.replace('/brx%3AdoubleDeskLarge','')
                                                    productWithColors.backgroundColor = selectedColor?.backgroundColor
                                                    return productWithColors
                                                }
                                            )


                                        models.push(newModel) 
                                    }
                                    return models;
                                }, 
                                []); 
                                
                            setModels(newModels);          

                            
                        } else {
                            console.log(result.message)
                        }
                    },
                        (error) => {
                            console.log(error);
                        })
                    .then(() => setLoading(0))
            )
    }

    React.useEffect(() => {
        init();
    }, []);

    return (
        <GeneralContext.Provider value={{
            colors,      
            families,      
            //filterAttribute,
            //setFilterAttribute,
            products,
            loading,
            selectedFilters,
            setSelectedFilters,
            startState,
            selectedFamily,
            setSelectedFamily,
            setSelectedRetailer,
            selectedColor,
            setSelectedColor,            
            models,            
            start,
            setStart,
            handleBack,
            selectedSku, 
            setSelectedSku,
            allFamilyObject,
            allColorObject,
            changeUrl,
            isMobile, 
            setIsMobile,
            mdaFamilyList

        }}>
            {props.children}
        </GeneralContext.Provider>
    );
};
